import store from '@/libs/store'
import Vue from 'vue'

const utils = {
	countryToCurrency (country) {
		const currency = {
			'de' : 'EUR',
			'at' : 'EUR',
			'us' : 'USD',
			'ch' : 'CHF'
		};
		return currency[country];
	},
	countryToLocale (country) {
		const locale = {
			'de' : 'de-DE',
			'at' : 'de-AT',
			'us' : 'en',
			'ch' : 'de-CH'
		};
		return locale[country]
	},
	addUnitToLabel(filter, label, unitIndex) {
		if (!filter.unit) return label

		const default_option = filter.values.find(val => val.default)

		if (default_option && default_option.label === label) return label

		const option_in_values = filter.values.find(val => val.label === label)

		let unit = filter.unit

		if(Array.isArray(unit)) {
			unit = filter.unit[unitIndex] || filter.unit[0];
		}
		if (option_in_values && option_in_values.unit) unit = option_in_values.unit

		if (unit.length <= 2) label = `${label}${unit}`
		else label = (`${label} ${unit}`)

		return label
	},

	getLabelForSelectedValue(filter, value, showFilterLabelIfNoUnit =  false) {
		let label = ''

		if (Array.isArray(value)) {
			const hasUnit = value.length === 3;
			label = []
			value.forEach((val, key) => {
				if(hasUnit && key === 0) {
					return;
				}
				label.push(this.addUnitToLabel(filter, val, value[0]))
			});

			label = label.join(filter.delimiter || ' - ')

			if (showFilterLabelIfNoUnit && !filter.unit) {
				label = filter.label + ': ' + label
			}

		} else if (value instanceof Object) {
			label = this.addUnitToLabel(filter, value.label || value.value)
		}
		else {
			label = this.addUnitToLabel(filter, value)
		}

		return label
	},

	getDisplayLabel(filter, onlyOne) {
		if(filter.type === 'duration') {
			if(filter.selectedValues) {
				if (filter.selectedValues[0].default === true && filter.selectedValues[1].default === true) {
					return filter.selectedValues[1].label;
				} else {
					if(filter.selectedValues[1].default) {
						return filter.selectedValues[0].label;
					}else {
						return filter.selectedValues[0].label + ', ' + this.getLabelForSelectedValue(filter, filter.selectedValues[1])
					}

				}
			}
			return filter.values.find(v => v.default).label;

		}
		if (store.actions.getDisabledStatus(filter)) return filter.default_displayed || filter.disabled_text

		let text = []

		if (filter.selectedValues && filter.selectedValues.length) {
			if (onlyOne && filter.selectedValues.length > 1) {
				text.push(`${filter.selectedValues.length} ausgewählt`)
			} else {
				for (let value of filter.selectedValues) {
					text.push(this.getLabelForSelectedValue(filter, value))
				}
			}
		} else if (filter.values && filter.values.length) {
			text.push(filter.values.find(val => {
				return val.default
			}).label)
		} else if (filter.default_displayed){
			text.push(filter.default_displayed)
		}

		// separate the values
		return text.join(filter.delimiter || ', ')
	}
}

Vue.prototype.$utils = utils

export default utils
